export default function() {
    return {
        coachingTracks: [],
        coachCoachingBlocks: [],
        registration_code: '',

        forceBack: false,
        previousComponent: "",

        dropIns: [],
        registerDropInCoachingSession: {},
        registerDropInCoachingSessionDialog: false,
        registerDropInCoachingSessionLevelConfirmed: false,
        registerWaitlistDropInCoachingSessionConfirmed: false,
        registerDropInCoachingSessionLevelType: false,
        registerDropInCoachingSessionLevelEvent: false,
        registerDropInCoachingSessionLevel: false,
        registerDropInCoachingSessionLevelDialog: false,
        confirmWaitlistDialog: false,
        dropInCoachingSessionIsFullDialog: false,
        calcelDropInCoachingSessionDialog: false,
        viewMoreDropInCoachingSessionDialog: false,
        changeRegistrationDropInDialog: false,

        coachingBlocks: [],
        registerCoachingTrack: {},
        registerCoachingTrackDialog: false,
        confirmRegisterCoachingTrackDialog: false,
        cancelRegisterCoachingTrackDialog: false,
        viewMoreCoachingTrackDialog: false,
        changeRegistrationCtDialog: false,

        registerMindBreak: {},
        registerMindBreakDialog: false,
        viewMoreMindBreakDialog: false,

        isDataLoaded: null,
        isDropInDataLoaded: null,
        isCTDataLoaded: null,
        coachingBlocksDataLoaded: null,
    }
}
